import {gql} from 'graphql-tag';

export const findInvoiceAbleJobs = gql
    `query findInvoiceAbleJobs($orgId: String!, $createdTo: String!, $pageNo: Float!, $pageSize: Float!,
    $searchKey: String!,  $invoiceType: InvoiceType!, $toDate: DateTime!, $fromDate: DateTime!, $types: [String!]!, $labelIds: [String!]) {
        findInvoiceAbleJobs(orgId: $orgId, createdTo: $createdTo, pageNo: $pageNo, pageSize: $pageSize,
        searchKey: $searchKey, invoiceType: $invoiceType, fromDate: $fromDate, toDate: $toDate, types: $types, labelIds: $labelIds) {
            data {
                jobRefId
                jobTitle
                shipper
                consignee
                shippingLine
                completedLoads
                pendingLoads
                contractRefNo
                customerRefNo
                createdTo
                orgPartnerId
                workFlowId
            }
            totalElements
            pageNo
            pageSize
        }
    }`;

export const countCompletedLoadsByCreatedTo = gql
    `query countCompletedLoadsByCreatedTo($orgId: String!, $createdToIds: [String!]! , $isCompleted: Boolean!,
    $invoiceType: InvoiceType!, $toDate: DateTime!, $fromDate: DateTime!, $types: [String!]!, $searchKey: String!, $labelIds: [String!]){
        countCompletedLoadsByCreatedTo(
              orgId: $orgId,
              createdToIds: $createdToIds,
              isCompleted: $isCompleted,
              invoiceType: $invoiceType,
              fromDate: $fromDate,
              toDate: $toDate,
              types: $types,
              searchKey: $searchKey,
              labelIds: $labelIds
            ){
            createdTo
            count
        }
    } `;

export const createInvoice = gql
    `mutation createInvoice($createInvoiceInput: CreateInvoiceInput!){
        createInvoice(createInvoiceInput: $createInvoiceInput){
            _id
            type
            invoiceRefNo
        }
    }`;

export const updateReadyToInvoiceCostsDiscounts = gql `mutation updateReadyToInvoiceCostsDiscounts($UpdateReadyToInvoiceDiscountCostInput: UpdateReadyToInvoiceDiscountCostInput!) {
    updateReadyToInvoiceCostsDiscounts(updateReadyToInvoiceCostsAndDiscountsInput: $UpdateReadyToInvoiceDiscountCostInput) {
        _id,
        jobRefId,
        contractRefNo,
        jobTitle,
        jpmId,
        orgId,
        rateCard,
        createdTo,
        consignee,
        shippingLine,
        shipper,
        serviceProvider
        loadId,
        loadNumber,
        loadCost,
        jpmId,
        completed,
        invoiced,
        containerType,
        jobTitle,
        rateCardCalculationRequest{
            rateSheet{
                defaultOrgCurrencyCode,
                currencyCode,
                exchangeRate,
                type,
                rateUnit,
                ratePerUnit,
                weightConversionRatios
            }
            weightInLoadKg
            trips{
                distance
            }
        },
        paymentTerm{
            advance
            creditDays
            paymentType
        },
        expenses{
            id
            amount
            costDescription
          paymentType
          feeType
        }
        locations
        operationId
        addedDiscount{
            id
            amount
            costDescription
          paymentType
        }
        addedOtherCost{
            id
            amount
            costDescription
          paymentType
        }
        addedAdditionalCost{
            id
            amount
            costDescription
          paymentType
        }
        commissions{
            id
            amount
            costDescription
            paymentType
            feeType
        }
    }
  }`;

export const updateInvoice = gql
    `mutation updateInvoice($updateInvoiceInput: UpdateInvoiceInput!){
        updateInvoice(updateInvoiceInput:$updateInvoiceInput){
            _id
            invoiceRefNo
            parentInvoiceRefNo
            invoiceName
            jobTitles
            orgId
            internalRefNos
            contractRefNos
            createdAt
            stateUpdatedAt
            rejectedBy
            rejectedDueTo
            rejectedDate
            preparedBy
            serviceProvider
            createdTo
            customerRefNo
            loads{
                _id
                loadId
                loadNumber
                loadCost
                rateSheetType
                rateUnit
                ratePerUnit
                weightInLoadKg
                weightInBillingUnit
                costs{
                    id
                    description
                    value
                    feeType
                }
                jpmId
                jobRefId
                total
                containerType
                jobTitle
                defaultOrgCurrencyCode
                currencyCode
                exchangeRate
                paymentTerm{
                    advance
                    creditDays
                    paymentType
                }
                rateCard
                locations
                distance
                operationId
                createdTo
                addedDiscount{
                    id
                    description
                    value
                    paymentType
                }
                addedOtherCost{
                    id
                    description
                    value
                    paymentType
                }
                addedAdditionalCost{
                    id
                    description
                    value
                    paymentType
                }
                vehicleCategories
                commissions{
                    id
                    description
                    value
                    paymentType
                    feeType
                }
                completedDate
                fuelRate
                fuelEfficiency
                vehicleIds
                vehicleNumbers
            }
            additionalCosts{
                id
                description
                value
            }
            loadsCosts{
                id
                description
                value
            }
            progressStep
            approvalState
            overdueState
            tab
            taxes{
                id
                description
                value
                paymentType
            }
            discount{
                id
                description
                value
                paymentType
            }
            otherCosts{
                id
                description
                value
                paymentType
            }
            total
            currency{
                defaultCurrency
                currentCurrency
                currencyRate
            }
            suspendedVat
            invoicePaymentTerm{
                advance
                creditDays
                paymentType
            }
            invoicePaymentTermStr
            loadsExpandState
            defaultOrgCurrencyCode
            currencyCode
            exchangeRate
            type
            subTotal
            dueDate
            remarks
            uploadInvoice
            uploadedInvoiceDocId
            supportDocumentIds
            commitmentDetails  {
                organizationId
                fromDate
                toDate
                blocks {
                    amount
                    commitmentKilometers
                    isCommitmentExtraKmCharge
                    commitmentExtraKmCharge
                    isAllVehicle
                    vehicles
                    vehicleCategory
                    vehicleCategoryName
                    vehicleContributions{
                        distance
                        vehicleCategory
                        vehicleId
                        vehicleNumber
                        loadId
                        loadNumber
                        isCommitment
                        fuelAllowanceAmount
                        currentDateTime
                        fuelRate
                        invoiced
                        fuelEfficiency
                    }
                    loadsExtraKMCosts{
                        id
                        description
                        value
                    }
                    affectedDays
                    fuelEfficiency
                    isFuelAllowance
                    fuelAllowanceType
                    fixedFuelAllowanceType
                    fuelRelatedData{
                        date
                        fuelRate{
                            rateId
                            fuelType
                            currentRate
                            newRate
                            customerContractIds
                            supplierContractIds
                            rateCardIds
                            selectAllCustomer
                            selectAllSupplier
                            selectAllRateCards
                        }
                        commitmentRate
                        extraKmRate
                        usedKMbetweenRange
                        valueOfFirstPart
                        valueOfSecondPart
                        remainingKm
                        loadContributions
                    }
                    fixedFuelAllowanceAmount
                }
                rateCardId
                contractName
            }
            childInvoices{
                _id
                invoiceRefNo
                parentInvoiceRefNo
                invoiceName
                jobTitles
                orgId
                internalRefNos
                contractRefNos
                createdAt
                stateUpdatedAt
                rejectedBy
                rejectedDueTo
                rejectedDate
                preparedBy
                serviceProvider
                createdTo
                customerRefNo
                additionalCosts{
                    id
                    description
                    value
                }
                loadsCosts{
                    id
                    description
                    value
                }
                progressStep
                approvalState
                overdueState
                tab
                taxes{
                    id
                    description
                    value
                    paymentType
                }
                loads{
                    _id
                    loadId
                    loadNumber
                    loadCost
                    rateSheetType
                    rateUnit
                    ratePerUnit
                    weightInLoadKg
                    weightInBillingUnit
                    costs{
                        id
                        description
                        value
                        feeType
                    }
                    jpmId
                    jobRefId
                    total
                    containerType
                    jobTitle
                    defaultOrgCurrencyCode
                    currencyCode
                    exchangeRate
                    paymentTerm{
                        advance
                        creditDays
                        paymentType
                    }
                    rateCard
                    locations
                    distance
                    operationId
                    createdTo
                    addedDiscount{
                        id
                        description
                        value
                        paymentType
                    }
                    addedOtherCost{
                        id
                        description
                        value
                        paymentType
                    }
                    addedAdditionalCost{
                        id
                        description
                        value
                        paymentType
                    }
                    vehicleIds
                    vehicleNumbers
                    commissions{
                        id
                        description
                        value
                        paymentType
                        feeType
                    }
                    completedDate
                    fuelRate
                    fuelEfficiency
                }
                discount{
                    id
                    description
                    value
                    paymentType
                }
                otherCosts{
                    id
                    description
                    value
                    paymentType
                }
                total
                currency{
                    defaultCurrency
                    currentCurrency
                    currencyRate
                }
                suspendedVat
                invoicePaymentTerm{
                    advance
                    creditDays
                    paymentType
                }
                invoicePaymentTermStr
                loadsExpandState
                defaultOrgCurrencyCode
                currencyCode
                exchangeRate
                type
            }
        }
    } `;

export const removeLoad = gql
    `mutation removeLoad($id: String!, $invoiceType: InvoiceType!, $invoiceId: String!){
        removeLoad(id: $id,invoiceType: $invoiceType,  invoiceId: $invoiceId){
            _id
            invoiceRefNo
            parentInvoiceRefNo
            invoiceName
            jobTitles
            orgId
            internalRefNos
            contractRefNos
            createdAt
            preparedBy
            serviceProvider
            createdTo
            customerRefNo
            loads{
                _id
                loadId
                loadNumber
                loadCost
                rateSheetType
                rateUnit
                ratePerUnit
                weightInLoadKg
                weightInBillingUnit
                costs{
                    id
                    description
                    value
                    feeType
                }
                jpmId
                jobRefId
                total
                containerType
                jobTitle
                defaultOrgCurrencyCode
                currencyCode
                exchangeRate
                paymentTerm{
                    advance
                    creditDays
                    paymentType
                }
                rateCard
                locations
                operationId
                addedDiscount{
                    id
                    description
                    value
                    paymentType
                }
                addedOtherCost{
                    id
                    description
                    value
                    paymentType
                }
                addedAdditionalCost{
                    id
                    description
                    value
                    paymentType
                }
                commissions{
                    id
                    description
                    value
                    paymentType
                    feeType
                }
            }
            additionalCosts{
                id
                description
                value
            }
            loadsCosts{
                id
                description
                value
            }
            progressStep
            approvalState
            overdueState
            tab
            taxes{
                id
                description
                value
                paymentType
            }
            discount{
                id
                description
                value
                paymentType
            }
            otherCosts{
                id
                description
                value
                paymentType
            }
            total
            currency{
                defaultCurrency
                currentCurrency
                currencyRate
            }
            suspendedVat
            invoicePaymentTerm{
                advance
                creditDays
                paymentType
            }
            invoicePaymentTermStr
            loadsExpandState
            defaultOrgCurrencyCode
            currencyCode
            exchangeRate
        }
    }`;

export const removeAllLoads = gql
    `mutation removeAllLoads($invoiceId: String!, $invoiceType: InvoiceType!){
        removeAllLoads(invoiceId: $invoiceId, invoiceType: $invoiceType){
            _id
            invoiceRefNo
            parentInvoiceRefNo
            invoiceName
            jobTitles
            orgId
            internalRefNos
            contractRefNos
            createdAt
            preparedBy
            serviceProvider
            createdTo
            customerRefNo
            loads{
                _id
                loadId
                loadNumber
                loadCost
                rateSheetType
                rateUnit
                ratePerUnit
                weightInLoadKg
                weightInBillingUnit
                costs{
                    id
                    description
                    value
                    feeType
                }
                jpmId
                jobRefId
                total
                containerType
                jobTitle
                defaultOrgCurrencyCode
                currencyCode
                exchangeRate
                paymentTerm{
                    advance
                    creditDays
                    paymentType
                }
                rateCard
                locations
                operationId
                addedDiscount{
                    id
                    description
                    value
                    paymentType
                }
                addedOtherCost{
                    id
                    description
                    value
                    paymentType
                }
                addedAdditionalCost{
                    id
                    description
                    value
                    paymentType
                }
                commissions{
                    id
                    description
                    value
                    paymentType
                    feeType
                }
            }
            additionalCosts{
                id
                description
                value
            }
            loadsCosts{
                id
                description
                value
            }
            progressStep
            approvalState
            overdueState
            tab
            taxes{
                id
                description
                value
                paymentType
            }
            discount{
                id
                description
                value
                paymentType
            }
            otherCosts{
                id
                description
                value
                paymentType
            }
            total
            currency{
                defaultCurrency
                currentCurrency
                currencyRate
            }
            suspendedVat
            invoicePaymentTerm{
                advance
                creditDays
                paymentType
            }
            invoicePaymentTermStr
            loadsExpandState
            defaultOrgCurrencyCode
            currencyCode
            exchangeRate
        }
    }`;

export const addLoadsToInvoice = gql
    `mutation addLoadsToInvoice($invoiceId: String!, $jpmIds: [String!]!, $invoiceType: InvoiceType!){
        addLoadsToInvoice(invoiceId: $invoiceId, jpmIds: $jpmIds, invoiceType: $invoiceType){
            _id
            invoiceRefNo
            parentInvoiceRefNo
            invoiceName
            jobTitles
            orgId
            internalRefNos
            contractRefNos
            createdAt
            preparedBy
            serviceProvider
            createdTo
            customerRefNo
            loads{
                _id
                loadId
                loadNumber
                loadCost
                rateSheetType
                rateUnit
                ratePerUnit
                weightInLoadKg
                weightInBillingUnit
                costs{
                    id
                    description
                    value
                    feeType
                }
                jpmId
                jobRefId
                total
                containerType
                jobTitle
                defaultOrgCurrencyCode
                currencyCode
                exchangeRate
                paymentTerm{
                    advance
                    creditDays
                    paymentType
                }
                rateCard
                locations
                operationId
                addedDiscount{
                    id
                    description
                    value
                    paymentType
                }
                addedOtherCost{
                    id
                    description
                    value
                    paymentType
                }
                addedAdditionalCost{
                    id
                    description
                    value
                    paymentType
                }
                commissions{
                    id
                    description
                    value
                    paymentType
                    feeType
                }
                vehicleCategories
            }
            additionalCosts{
                id
                description
                value
            }
            loadsCosts{
                id
                description
                value
            }
            progressStep
            approvalState
            overdueState
            tab
            taxes{
                id
                description
                value
                paymentType
            }
            discount{
                id
                description
                value
                paymentType
            }
            otherCosts{
                id
                description
                value
                paymentType
            }
            total
            currency{
                defaultCurrency
                currentCurrency
                currencyRate
            }
            suspendedVat
            invoicePaymentTerm{
                advance
                creditDays
                paymentType
            }
            invoicePaymentTermStr
            loadsExpandState
            defaultOrgCurrencyCode
            currencyCode
            exchangeRate
        }
    }`;

export const findCustomers = gql
    `query findCustomers($toDate: DateTime!, $fromDate: DateTime!, $orgId: String!, $types: [String!]!, $searchKey: String!, $labelIds: [String!]) {
        findCustomers(fromDate: $fromDate, toDate: $toDate, orgId: $orgId, types: $types, searchKey: $searchKey, labelIds: $labelIds)
    }`;

export const findSuppliers = gql
    `query findSuppliers($toDate: DateTime!, $fromDate: DateTime!, $orgId: String!, $types: [String!]!, $searchKey: String!, $labelIds: [String!]) {
        findSuppliers(fromDate: $fromDate, toDate: $toDate, orgId: $orgId, types: $types, searchKey: $searchKey, labelIds: $labelIds)
    }`;

export const findLoadsByJobRefIdAndIsCompleted = gql
    `query findLoadsByJobRefIdAndIsCompleted($orgId: String!, $createdTo: String!, $jobRefId: String!, $isCompleted: Boolean! , $pageNo: Float!, $pageSize: Float!, $invoiceType: InvoiceType!, $labelIds: [String!]){
        findLoadsByJobRefIdAndIsCompleted(orgId: $orgId, createdTo: $createdTo, jobRefId: $jobRefId, isCompleted: $isCompleted, pageNo: $pageNo, pageSize: $pageSize, invoiceType: $invoiceType, labelIds: $labelIds){
            totalElements
            pageNo
            pageSize
            data {
                _id,
                jobRefId,
                contractRefNo,
                jobTitle,
                jpmId,
                orgId,
                rateCard,
                createdTo,
                consignee,
                shippingLine,
                shipper,
                serviceProvider
                loadId,
                loadNumber,
                loadCost,
                jpmId,
                completed,
                invoiced,
                containerType,
                jobTitle,
                rateCardCalculationRequest{
                    rateSheet{
                        defaultOrgCurrencyCode,
                        currencyCode,
                        exchangeRate,
                        type,
                        rateUnit,
                        ratePerUnit,
                        weightConversionRatios
                    }
                    weightInLoadKg
                    trips{
                        distance
                    }
                },
                paymentTerm{
                    advance
                    creditDays
                    paymentType
                },
                expenses{
                    id
                    amount
                    costDescription
                    paymentType
                    feeType
                }
                locations
                operationId
                addedDiscount{
                    id
                    amount
                    costDescription
                    paymentType
                }
                addedOtherCost{
                    id
                    amount
                    costDescription
                    paymentType
                }
                addedAdditionalCost{
                    id
                    amount
                    costDescription
                    paymentType
                }
                vehicleCategories
                commissions{
                    id
                    amount
                    costDescription
                    paymentType
                    feeType
                }
            }
        }
    }`;

export const findLoadsByJobRefId = gql
    `query findLoadsByJobRefId($orgId: String!, $jobRefId: String!, $pageNo: Float!, $pageSize: Float!){
        findLoadsByJobRefId(orgId: $orgId, jobRefId: $jobRefId, pageNo: $pageNo, pageSize: $pageSize){
            totalElements
            pageNo
            pageSize
            data {
                jobRefId,
                jobTitle,
                jpmId,
                orgId,
                rateCard,
                createdTo,
                consignee,
                shippingLine,
                shipper,
                serviceProvider
                loadId,
                loadCost,
                loadNumber,
                jpmId,
                completed,
                invoiced
            }
        }
    }`;

export const findAllCompletedLoadsByOrg = gql
    `query findAllCompletedLoadsByOrg($orgId: String!,$createdTo: String!, $isCompleted: Boolean!, $searchKey: String!,
     $invoiceType: InvoiceType!, $fromDate: DateTime!, $toDate: DateTime!, $types: [String!]!, $labelIds: [String!]){
        findAllCompletedLoadsByOrg(orgId: $orgId, createdTo: $createdTo, isCompleted: $isCompleted,
         searchKey: $searchKey,  invoiceType: $invoiceType,fromDate: $fromDate, toDate: $toDate, types: $types, labelIds: $labelIds){
            _id,
            jobRefId,
            contractRefNo,
            jobTitle,
            jpmId,
            orgId,
            rateCard,
            createdTo,
            consignee,
            shippingLine,
            shipper,
            serviceProvider
            loadId,
            loadNumber,
            jpmId,
            completed,
            invoiced,
            loadCost,
            containerType,
            jobTitle,
            rateCardCalculationRequest{
                rateSheet{
                    defaultOrgCurrencyCode,
                    currencyCode,
                    exchangeRate,
                    type,
                    rateUnit,
                    ratePerUnit,
                    weightConversionRatios
                }
                weightInLoadKg
                trips{
                    distance
                }
            },
            paymentTerm{
                advance,
                creditDays,
                paymentType
            },
            expenses{
                id,
                amount,
                costDescription
                paymentType
                feeType
            }
            locations
            operationId
            addedDiscount{
                id
                amount
                costDescription
                paymentType
            }
            addedOtherCost{
                id
                amount
                costDescription
                paymentType
            }
            addedAdditionalCost{
                id
                amount
                costDescription
                paymentType
            }
            commissions{
                id
                amount
                costDescription
                paymentType
                feeType
                }
        }
    }`;

export const findAllCompletedLoadsByJob = gql
    `query findAllCompletedLoadsByJob($orgId: String!, $jobRefId: String!, $isCompleted: Boolean!, $labelIds: [String!]){
        findAllCompletedLoadsByJob(orgId: $orgId, jobRefId: $jobRefId, isCompleted: $isCompleted, labelIds: $labelIds){
            _id,
            jobRefId,
            contractRefNo,
            jobTitle,
            jpmId,
            orgId,
            rateCard,
            createdTo,
            consignee,
            shippingLine,
            shipper,
            serviceProvider
            loadId,
            loadNumber,
            jpmId,
            completed,
            invoiced,
            loadCost,
            containerType,
            jobTitle,
            rateCardCalculationRequest{
                rateSheet{
                    defaultOrgCurrencyCode,
                    currencyCode,
                    exchangeRate,
                    type,
                    rateUnit,
                    ratePerUnit,
                    weightConversionRatios
                }
                weightInLoadKg
                trips{
                    distance
                }
            },
            paymentTerm{
                advance,
                creditDays,
                paymentType
            },
            expenses{
                id,
                amount,
                costDescription,
                paymentType,
                feeType
            }
            locations
            operationId
            addedDiscount{
                id
                amount
                costDescription
                paymentType
            }
            addedOtherCost{
                id
                amount
                costDescription
                paymentType
            }
            addedAdditionalCost{
                id
                amount
                costDescription
                paymentType
            }
            commissions{
              id
              amount
              costDescription
              paymentType
              feeType
            }
        }
    }`;

    export const findAllCompletedLoadsByJobAll = gql
    `query findAllCompletedLoadsByJobAll($orgId: String!, $jobRefId: String!, $isCompleted: Boolean! ){
        findAllCompletedLoadsByJobAll(orgId: $orgId, jobRefId: $jobRefId, isCompleted: $isCompleted){
            _id,
            jobRefId,
            contractRefNo,
            jobTitle,
            jpmId,
            orgId,
            rateCard,
            createdTo,
            consignee,
            shippingLine,
            shipper,
            serviceProvider
            loadId,
            loadNumber,
            jpmId,
            completed,
            invoiced,
            loadCost,
            containerType,
            jobTitle,
            type,
            rateCardCalculationRequest{
                rateSheet{
                    defaultOrgCurrencyCode,
                    currencyCode,
                    exchangeRate,
                    type,
                    rateUnit,
                    ratePerUnit,
                    weightConversionRatios
                }
                weightInLoadKg
                trips{
                    distance
                }
            },
            paymentTerm{
                advance,
                creditDays,
                paymentType
            },
            expenses{
                id,
                amount,
                costDescription,
                paymentType,
                feeType
            }
            locations
            operationId
            addedDiscount{
                id
                amount
                costDescription
                paymentType
            }
            addedOtherCost{
                id
                amount
                costDescription
                paymentType
            }
            addedAdditionalCost{
                id
                amount
                costDescription
                paymentType
            }
            commissions{
              id
              amount
              costDescription
              paymentType
              feeType
            }
        }
    }`;    

    export const findAllCompletedLoadsByLoadIdsAll = gql
    `query findAllCompletedLoadsByLoadIdsAll($orgId: String!, $loadIds: [String!]!, $isCompleted: Boolean! ){
        findAllCompletedLoadsByLoadIdsAll(orgId: $orgId, loadIds: $loadIds, isCompleted: $isCompleted){
            _id,
            jobRefId,
            contractRefNo,
            jobTitle,
            jpmId,
            orgId,
            rateCard,
            createdTo,
            consignee,
            shippingLine,
            shipper,
            serviceProvider
            loadId,
            loadNumber,
            jpmId,
            completed,
            invoiced,
            loadCost,
            containerType,
            jobTitle,
            type,
            rateCardCalculationRequest{
                rateSheet{
                    defaultOrgCurrencyCode,
                    currencyCode,
                    exchangeRate,
                    type,
                    rateUnit,
                    ratePerUnit,
                    weightConversionRatios
                }
                weightInLoadKg
                trips{
                    distance
                }
            },
            paymentTerm{
                advance,
                creditDays,
                paymentType
            },
            expenses{
                id,
                amount,
                costDescription,
                paymentType,
                feeType
            }
            locations
            operationId
            addedDiscount{
                id
                amount
                costDescription
                paymentType
            }
            addedOtherCost{
                id
                amount
                costDescription
                paymentType
            }
            addedAdditionalCost{
                id
                amount
                costDescription
                paymentType
            }
            commissions{
              id
              amount
              costDescription
              paymentType
              feeType
            }
        }
    }`;    

export const findInvoicesByInvoiceTypeAndApprovalType = gql
    `query findInvoicesByInvoiceTypeAndApprovalType($orgId: String!, $tabType: TabType!, $toDate: DateTime!, $fromDate: DateTime!,
        $approvalType: ApprovalStateType!, $pageNo: Float!, $pageSize: Float!, $invoiceType: InvoiceType!,
         $searchKey: String!, $createdTo: [String!], $all: Boolean!, $labelIds: [String!]){
        findInvoicesByInvoiceTypeAndApprovalType(
            orgId: $orgId,
            tabType: $tabType,
            approvalType: $approvalType,
            pageNo: $pageNo,
            pageSize: $pageSize,
            invoiceType: $invoiceType,
            searchKey: $searchKey,
            fromDate: $fromDate,
            toDate: $toDate,
            createdTo: $createdTo,
            all: $all,
            labelIds: $labelIds
        ){
            totalElements,
            pageNo,
            pageSize,
            data{
                _id
                invoiceRefNo
                createdAt
                createdTo
                preparedBy
                loads{
                    jpmId
                }
                total
                approvalState
                tab
                currencyCode
                type
                uploadInvoice
                stateUpdatedAt
                rejectedBy
                rejectedDueTo
                rejectedDate
            }
        }
    }`;

export const findReceivedInvoicesByApprovalState = gql
    `query findReceivedInvoicesByApprovalState($createdTo: String!, $approvalType: ApprovalStateType!,
        $pageNo: Float!, $pageSize: Float!, $invoiceType: InvoiceType!, $fromDate: DateTime!, $toDate: DateTime!,
        $searchKey: String!, $all: Boolean!){
        findReceivedInvoicesByApprovalState(
            createdTo: $createdTo,
            approvalType: $approvalType,
            pageNo: $pageNo,
            pageSize: $pageSize,
            invoiceType: $invoiceType,
            fromDate: $fromDate,
            toDate: $toDate,
            searchKey: $searchKey,
            all: $all
        ){
            totalElements,
            pageNo,
            pageSize,
            data{
                _id
                invoiceRefNo
                createdAt
                orgId
                createdTo
                total
                approvalState
                tab
                currencyCode
                type
                uploadInvoice
                stateUpdatedAt
                rejectedBy
                rejectedDueTo
                rejectedDate
                loads{
                    _id
                }
            }
        }
    }`;

export const findCommitmentInvoiceOrganizationIds = gql
    `query findCommitmentInvoiceOrganizationIds($orgId: String!, $invoiceType: InvoiceType!, $fromDate: DateTime!,
    $toDate: DateTime!, $labelIds: [String!]){
        findCommitmentInvoiceOrganizationIds(
              orgId: $orgId,
              invoiceType: $invoiceType,
              fromDate: $fromDate,
              toDate: $toDate,
              labelIds: $labelIds,
            )
    }`;

export const findCommitmentInvoicesForOrganization = gql
    `query findCommitmentInvoicesForOrganization($searchKey: String!, $pageSize: Float!, $pageNo: Float!, $invoiceType: InvoiceType!,
    $organizationId: String!, $orgId: String!, $toDate: DateTime!, $fromDate: DateTime!, $labelIds: [String!]){
        findCommitmentInvoicesForOrganization(
              searchKey: $searchKey,
              pageSize:  $pageSize,
              pageNo: $pageNo,
              invoiceType: $invoiceType,
              organizationId:$organizationId,
              orgId: $orgId,
              fromDate: $fromDate,
              toDate: $toDate,
              labelIds: $labelIds,
            ){
            totalElements
            pageNo
            pageSize
            data{
                _id
                invoiceName
                parentInvoiceRefNo
                invoiceRefNo
                createdAt
                orgId
                loads{
                  loadCost
                }
                total
                commitmentDetails{
                    organizationId
                    fromDate
                    toDate
                    contractName
                }
                type
            }
        }
    }`;

export const findByInvoiceTypeAndOverdueType = gql
    `query findByInvoiceTypeAndOverdueType($orgId: String!, $tabType: TabType!, $toDate: DateTime!, $fromDate: DateTime!,
    $overdueState: OverdueStateType!, $pageNo: Float!, $pageSize: Float!, $invoiceType: InvoiceType!, , $searchKey: String!, $labelIds: [String!]){
        findByInvoiceTypeAndOverdueType(
            orgId: $orgId,
            tabType: $tabType,
            overdueState: $overdueState,
            pageNo: $pageNo,
            pageSize: $pageSize,
            invoiceType: $invoiceType,
            searchKey: $searchKey,
            fromDate: $fromDate,
            toDate: $toDate,
            labelIds: $labelIds
        ){
            totalElements,
            pageNo,
            pageSize,
            data{
                _id
                invoiceRefNo
                createdAt
                createdTo
                total
                approvalState
                tab
                type
                uploadInvoice
                stateUpdatedAt
                rejectedBy
                rejectedDueTo
                rejectedDate
            }
        }
    }`;

export const findInvoiceById = gql
    `query findInvoiceById($id: String!){
        findInvoiceById(id: $id){
            _id
            invoiceRefNo
            parentInvoiceRefNo
            invoiceName
            jobTitles
            orgId
            internalRefNos
            contractRefNos
            createdAt
            stateUpdatedAt
            rejectedBy
            rejectedDueTo
            rejectedDate
            preparedBy
            serviceProvider
            createdTo
            customerRefNo
            loads{
                _id
                loadId
                loadNumber
                loadCost
                rateSheetType
                rateUnit
                ratePerUnit
                weightInLoadKg
                weightInBillingUnit
                costs{
                    id
                    description
                    value
                    feeType
                }
                jpmId
                jobRefId
                total
                containerType
                jobTitle
                defaultOrgCurrencyCode
                currencyCode
                exchangeRate
                paymentTerm{
                    advance
                    creditDays
                    paymentType
                }
                rateCard
                locations
                distance
                operationId
                createdTo
                addedDiscount{
                    id
                    description
                    value
                    paymentType
                }
                addedOtherCost{
                    id
                    description
                    value
                    paymentType
                }
                addedAdditionalCost{
                    id
                    description
                    value
                    paymentType
                }
                vehicleIds
                vehicleNumbers
                commissions{
                    id
                    description
                    value
                    paymentType
                    feeType
                }
                vehicleCategories
                completedDate
                fuelRate
                fuelEfficiency
            }
            additionalCosts{
                id
                description
                value
            }
            loadsCosts{
                id
                description
                value
            }
            progressStep
            approvalState
            overdueState
            tab
            taxes{
                id
                description
                value
                paymentType
            }
            discount{
                id
                description
                value
                paymentType
            }
            otherCosts{
                id
                description
                value
                paymentType
            }
            total
            currency{
                defaultCurrency
                currentCurrency
                currencyRate
            }
            suspendedVat
            invoicePaymentTerm{
                advance
                creditDays
                paymentType
            }
            invoicePaymentTermStr
            loadsExpandState
            defaultOrgCurrencyCode
            currencyCode
            exchangeRate
            type
            subTotal
            dueDate
            remarks
            uploadInvoice
            uploadedInvoiceDocId
            supportDocumentIds
            commitmentDetails  {
                organizationId
                fromDate
                toDate
                blocks {
                    amount
                    commitmentKilometers
                    isCommitmentExtraKmCharge
                    commitmentExtraKmCharge
                    isAllVehicle
                    vehicles
                    vehicleCategory
                    vehicleCategoryName
                    vehicleContributions{
                        distance
                        vehicleCategory
                        vehicleId
                        vehicleNumber
                        loadId
                        loadNumber
                        isCommitment
                        fuelAllowanceAmount
                        currentDateTime
                        fuelRate
                        invoiced
                        fuelEfficiency
                    }
                    loadsExtraKMCosts{
                        id
                        description
                        value
                    }
                    affectedDays
                    fuelEfficiency
                    isFuelAllowance
                    fuelAllowanceType
                    fixedFuelAllowanceType
                    fuelRelatedData{
                        date
                        fuelRate{
                            rateId
                            fuelType
                            currentRate
                            newRate
                            customerContractIds
                            supplierContractIds
                            rateCardIds
                            selectAllCustomer
                            selectAllSupplier
                            selectAllRateCards
                        }
                        commitmentRate
                        extraKmRate
                        usedKMbetweenRange
                        valueOfFirstPart
                        valueOfSecondPart
                        remainingKm
                        loadContributions
                    }
                    fixedFuelAllowanceAmount
                }
                rateCardId
                contractName
            }
            childInvoices {
                _id
                invoiceRefNo
                parentInvoiceRefNo
                invoiceName
                jobTitles
                orgId
                internalRefNos
                contractRefNos
                createdAt
                stateUpdatedAt
                rejectedBy
                rejectedDueTo
                rejectedDate
                preparedBy
                serviceProvider
                createdTo
                customerRefNo
                additionalCosts{
                    id
                    description
                    value
                }
                loadsCosts{
                    id
                    description
                    value
                }
                progressStep
                approvalState
                overdueState
                tab
                taxes{
                    id
                    description
                    value
                    paymentType
                }
                loads{
                    _id
                    loadId
                    loadNumber
                    loadCost
                    rateSheetType
                    rateUnit
                    ratePerUnit
                    weightInLoadKg
                    weightInBillingUnit
                    costs{
                        id
                        description
                        value
                        feeType
                    }
                    jpmId
                    jobRefId
                    total
                    containerType
                    jobTitle
                    defaultOrgCurrencyCode
                    currencyCode
                    exchangeRate
                    paymentTerm{
                        advance
                        creditDays
                        paymentType
                    }
                    rateCard
                    locations
                    distance
                    operationId
                    createdTo
                    addedDiscount{
                        id
                        description
                        value
                        paymentType
                    }
                    addedOtherCost{
                        id
                        description
                        value
                        paymentType
                    }
                    addedAdditionalCost{
                        id
                        description
                        value
                        paymentType
                    }
                    vehicleIds
                    vehicleNumbers
                    commissions{
                        id
                        description
                        value
                        paymentType
                        feeType
                    }
                    completedDate
                    fuelRate
                    fuelEfficiency
                }
                discount{
                    id
                    description
                    value
                    paymentType
                }
                otherCosts{
                    id
                    description
                    value
                    paymentType
                }
                total
                currency{
                    defaultCurrency
                    currentCurrency
                    currencyRate
                }
                suspendedVat
                invoicePaymentTerm{
                    advance
                    creditDays
                    paymentType
                }
                invoicePaymentTermStr
                loadsExpandState
                defaultOrgCurrencyCode
                currencyCode
                exchangeRate
                type
            }
            disputedItems {
                itemId
                level
                reference
                charge
                billed
                expected
                variance
                reason
                comment
                disputedAt
                disputedBy {
                    userId
                    name
                }
            }
        }
    }`;

export const fidByCountry = gql
    `query fidByCountry($countryCode: String!){
        findByCountry(countryCode:$countryCode){
            _id
            name
            percentage
            countryCode
        }
    }`;

export const changeRateCardForTrip = gql
  `mutation changeRateCardForTrip($jpmId: String!, $createdTo: String!, $rateCardId: String!){
  changeRateCardForTrip(jpmId:$jpmId, createdTo: $createdTo, rateCardId: $rateCardId )
}`;

export const uploadPdfAndGetId = gql
    `mutation uploadPdfAndGetId($orgId: String!, $invoiceId: String!){
        uploadPdfAndGetId(orgId: $orgId, invoiceId: $invoiceId)
    }`;

export const storeUploadedInvoiceDoc = gql
    `mutation storeUploadedInvoiceDoc($invoiceId: String!, $documentId: String!){
        storeUploadedInvoiceDoc(invoiceId: $invoiceId, documentId: $documentId){
            _id
        }
    }`;

export const addSupportDocuments = gql
    `mutation addSupportDocuments($invoiceId: String!, $documentIds: [String!]!){
        addSupportDocuments(invoiceId: $invoiceId, documentIds: $documentIds){
            _id
        }
    }`;

export const findAllCurrency = gql
    `query findAllCurrency{
        findAllCurrency{
            _id
            currency
            code
            countryCode
            shortCode
        }
    }`;
export const updateFuelRateInInvoiceQuery = gql
    `mutation updateFuelRateInInvoice($updateFuelRateInInvoice: FuelRateUpdateInvoiceInput!){
         updateFuelRateInInvoice(updateFuelRateInInvoice: $updateFuelRateInInvoice)
    }`;

export const changeInvoicedState = gql
    `mutation changeInvoicedState($updateVCStates: [UpdateVCStateInput!]!){
        changeInvoicedState(updateVCStates:$updateVCStates )
    }`;

export const findInvoicesByIds = gql
    `query findInvoicesByIds($invoiceIds: [String!]!){
        findInvoicesByIds(invoiceIds:$invoiceIds){
            _id
            invoiceRefNo
            parentInvoiceRefNo
            invoiceName
            jobTitles
            orgId
            internalRefNos
            contractRefNos
            createdAt
            stateUpdatedAt
            rejectedBy
            rejectedDueTo
            rejectedDate
            preparedBy
            serviceProvider
            createdTo
            customerRefNo
            additionalCosts{
                id
                description
                value
            }
            loadsCosts{
                id
                description
                value
            }
            progressStep
            approvalState
            overdueState
            tab
            taxes{
                id
                description
                value
                paymentType
            }
            loads{
                _id
                loadId
                loadNumber
                loadCost
                rateSheetType
                rateUnit
                ratePerUnit
                weightInLoadKg
                weightInBillingUnit
                costs{
                    id
                    description
                    value
                    feeType
                }
                jpmId
                jobRefId
                total
                containerType
                jobTitle
                defaultOrgCurrencyCode
                currencyCode
                exchangeRate
                paymentTerm{
                    advance
                    creditDays
                    paymentType
                }
                rateCard
                locations
                distance
                operationId
                createdTo
                addedDiscount{
                    id
                    description
                    value
                    paymentType
                }
                addedOtherCost{
                    id
                    description
                    value
                    paymentType
                }
                addedAdditionalCost{
                    id
                    description
                    value
                    paymentType
                }
                vehicleIds
                vehicleNumbers
                commissions{
                    id
                    description
                    value
                    paymentType
                    feeType
                }
                completedDate
                fuelRate
                fuelEfficiency
            }
            discount{
                id
                description
                value
                paymentType
            }
            otherCosts{
                id
                description
                value
                paymentType
            }
            total
            currency{
                defaultCurrency
                currentCurrency
                currencyRate
            }
            suspendedVat
            invoicePaymentTerm{
                advance
                creditDays
                paymentType
            }
            invoicePaymentTermStr
            loadsExpandState
            defaultOrgCurrencyCode
            currencyCode
            exchangeRate
            type
        }
    }`;

export const updateInvoicedState = gql
  `mutation updateInvoiceStateForFuelRateInvoices($invoiceIds: [String!]!, $invoiceType: InvoiceType!){
    updateInvoiceStateForFuelRateInvoices(invoiceIds:$invoiceIds, invoiceType:$invoiceType)
  }`;

export const updateExpenses = gql
  `mutation updateExpenses($id: String!, $expenses: [ExpenseInput!]!){
    updateExpenses(id: $id, expenses: $expenses){
      _id
    }
  }`;

export const downloadInvoicesDetailedReport = gql
  `mutation generateDetailedReportForInvoices(
    $orgId: String!,
    $userId: String!,
    $downloadType: String!,
    $selectAll: Boolean!,
    $selectedIds: [String!]!,
    $excludeIds: [String!],
    $toDate: DateTime,
    $fromDate: DateTime
  ){
    generateDetailedReportForInvoices(
      orgId: $orgId,
      userId: $userId,
      downloadType: $downloadType,
      selectAll: $selectAll,
      selectedIds: $selectedIds,
      excludeIds: $excludeIds,
      toDate: $toDate,
      fromDate: $fromDate
    ){
        success
        message
        metadata {
            eventId
            eventType
            userId
            orgId
            firebasePath
            status
            timestamp
        }
        error
    }
  }`;

export const findInvoicesByOrgIdAndJobRefId = gql
  `query findInvoicesByOrgIdAndJobRefId($orgId: String!, $jobRefId: String!){
    findInvoicesByOrgIdAndJobRefId(orgId: $orgId, jobRefId: $jobRefId){
      _id
      invoiceRefNo
      parentInvoiceRefNo
      invoiceName
      jobTitles
      orgId
      internalRefNos
      contractRefNos
      createdAt
      stateUpdatedAt
      rejectedBy
      rejectedDueTo
      rejectedDate
      preparedBy
      serviceProvider
      createdTo
      customerRefNo
      loads {
        _id
        loadId
        loadNumber
        loadCost
        jpmId
        jobRefId
        total
        containerType
        jobTitle
        defaultOrgCurrencyCode
        currencyCode
        exchangeRate
        rateCard
        locations
        distance
        operationId
        createdTo
        vehicleIds
        vehicleNumbers
        vehicleCategories
        completedDate
        fuelRate
        fuelEfficiency
        costs {
          id
          description
          value
          feeType
        }
        paymentTerm {
          advance
          creditDays
          paymentType
        }
        addedDiscount {
          id
          description
          value
          paymentType
        }
        addedOtherCost {
          id
          description
          value
          paymentType
        }
        addedAdditionalCost {
          id
          description
          value
          paymentType
        }
        commissions {
          id
          description
          value
          paymentType
          feeType
        }
      }
      additionalCosts {
        id
        description
        value
      }
      loadsCosts {
        id
        description
        value
      }
      progressStep
      approvalState
      overdueState
      tab
      taxes {
        id
        description
        value
        paymentType
      }
      discount {
        id
        description
        value
        paymentType
      }
      otherCosts {
        id
        description
        value
        paymentType
      }
      total
      currency {
        defaultCurrency
        currentCurrency
        currencyRate
      }
      suspendedVat
      invoicePaymentTerm {
        advance
        creditDays
        paymentType
      }
      invoicePaymentTermStr
      loadsExpandState
      defaultOrgCurrencyCode
      currencyCode
      exchangeRate
      type
      commitmentDetails {
        organizationId
        fromDate
        toDate
        rateCardId
        contractName
      }
      childInvoices {
        _id
        invoiceRefNo
        parentInvoiceRefNo
        invoiceName
        jobTitles
        orgId
        internalRefNos
        contractRefNos
        createdAt
        stateUpdatedAt
        rejectedBy
        rejectedDueTo
        rejectedDate
        preparedBy
        serviceProvider
        createdTo
        customerRefNo
        total
        type
      }
    }
  }`;

export const disputeInvoiceItem = gql
  `mutation disputeInvoiceItem($disputeInvoiceItemInput: DisputeInvoiceItemInput!){
    disputeInvoiceItem(disputeInvoiceItemInput: $disputeInvoiceItemInput){
      _id
      invoiceRefNo
      approvalState
      stateUpdatedAt
      rejectedBy
      rejectedDueTo
      rejectedDate
      disputedItems {
        itemId
        level
        reference
        charge
        billed
        expected
        variance
        reason
        comment
        disputedAt
        disputedBy {
          userId
          name
        }
      }
    }
  }`;

export const acceptInvoiceItem = gql
  `mutation acceptInvoiceItem($acceptInvoiceItemInput: AcceptInvoiceItemInput!){
    acceptInvoiceItem(acceptInvoiceItemInput: $acceptInvoiceItemInput){
      _id
      invoiceRefNo
      approvalState
      stateUpdatedAt
    }
  }`;
